import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function FreelancerVerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || 'your email';
  const message = location.state?.message || 'Check your email to verify your account.';

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a659e 0%, #2980b9 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, #1a659e 0%, #2980b9 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          fontSize: '40px'
        }}>
          ✉️
        </div>
        
        <h2 style={{
          fontSize: '28px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#333'
        }}>
          Check Your Email
        </h2>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          We've sent a verification link to <strong>{email}</strong>
          <br /><br />
          {message}
        </p>

        <div style={{
          padding: '16px',
          background: '#e3f2fd',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <p style={{ fontSize: '14px', color: '#1976d2', margin: 0, lineHeight: '1.6' }}>
            <strong>Next Steps:</strong><br />
            1. Click the link in your email<br />
            2. Log in with your credentials<br />
            3. Complete your freelancer profile
          </p>
        </div>

        <div style={{
          padding: '12px',
          background: '#fff3e0',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <p style={{ fontSize: '13px', color: '#e65100', margin: 0 }}>
            💡 Check your spam folder if you don't see the email within a few minutes.
          </p>
        </div>

        <button
          type="button"
          onClick={() => navigate('/login?redirect=/freelancer/profile')}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #1a659e 0%, #2980b9 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'transform 0.2s'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}

export default FreelancerVerifyEmail;
